<app-advanced-search
    (closeSiteMenu)="onCloseAdvancedSearchPage()"
    (search)="search($event)"
    [attributes]="attributes$ | async"
    [searchFilters]="searchFilters$ | async"
    [decorTypeOpen]="decorTypeOpen$ | async"
    [occasionTypeOpen]="occasionTypeOpen$ | async"
    [productTypeOpen]="productTypeOpen$ | async"
    [purposeTypeOpen]="purposeTypeOpen$ | async"
    [productCategoryTypeOpen]="productCategoryTypeOpen$ | async"
    [colorTypeOpen]="colorTypeOpen$ | async"
    [sortTypeOpen]="sortTypeOpen$ | async"
></app-advanced-search>
